import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionAppService } from '@services/compositions/composition-app.service';
import { DataTableComponent, DataTableEvent } from '../../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'composition-detail',
    templateUrl: './composition-detail.component.html',
    styleUrls: ['./composition-detail.component.scss'],
    providers: [CompositionService, CompositionAppService],
    standalone: false
})
export class CompositionDetailComponent implements OnInit {

  public title: string;

  public pageActions: PageAction[];

  public boundComposition: Models.Composition;

  public params: any;

  public isLoaded = false;

  public columns = [
    { prop: 'name', name: 'Composition App' },
    { prop: 'icon', name: 'Icon' }
  ];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  constructor(
    public compositionAppService: CompositionAppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private compositionService: CompositionService,
    private dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.params = {
      compositionId: this.activatedRoute.snapshot.params['id']
    };

    this.activatedRoute.params.subscribe(params => {
      this.params = {
        compositionId: params.id
      };
      return this.compositionService.get(params.id).then(composition => {
        this.boundComposition = composition;
        this.title = composition.title;
        this.createPageActions();
      });
    });

    return this.compositionService.get(this.activatedRoute.snapshot.params['id']).then(composition => {
      this.boundComposition = composition;
      this.title = 'Composition: ' + composition.title;
      this.isLoaded = true;
      this.createPageActions();
    });
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['compositions', this.boundComposition._id, 'apps', event.row._id, 'edit']);
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['compositions', this.boundComposition._id, 'apps', event.row._id]);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService.confirm('Remove app?').then(res => {
      if (!res) {
        return;
      }
      return this.compositionAppService.remove(event.row._id).then(() => this.dataTable.refresh()).catch(error => {
        const message = (error.error.message ? error.error.message : error.message);
        return this.dialogService.confirm(message, error.name);
      });
    });
  }

  private createPageActions(): void {
    this.pageActions = [new PageAction({
      icon: 'edit',
      title: 'Edit composition',
      callback: () => {
        this.router.navigate(['compositions', this.boundComposition._id, 'edit']);
      }
    }), new PageAction({
      icon: 'create_new_folder',
      title: 'Create app',
      disabled: !this.hasAvailableLanguages(),
      callback: () => {
        this.router.navigate(['compositions', this.boundComposition._id, 'apps', 'create']);
      }
    }), new PageAction({
      icon: 'link',
      title: 'Import connections',
      callback: () => {
        this.router.navigate(['compositions', this.boundComposition._id, 'imports']);
      }
    }), new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Composition Type',
        callback: () => {
          this.router.navigate(['composition-types/', this.boundComposition.typeId]);
        }
      }
    )];
  }

  private hasAvailableLanguages(): boolean {
    return this.boundComposition
      && this.boundComposition.screen
      && this.boundComposition.screen.availableLanguages
      && this.boundComposition.screen.availableLanguages.length > 0;
  }

}
